import React from "react";
import IconButton from "components/items/icon-button";

const ApplicationEditButton = props => <IconButton icon="edit" title="Edit" {...props} />;

export default ApplicationEditButton;
